export * from './AnimatedTick';
